/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { AddEquation, CustomBlending, DoubleSide, LinearFilter, OneMinusSrcAlphaFactor, ShaderMaterial, SrcAlphaFactor, Color } from 'three';
import { DistanceFieldShader } from '../../materials/shaders/DistanceFieldShader';
/**
 * concrete implementation of Text2DFont
 */
export class Text2DFontMSDF {
    constructor(textures, textureSize, lineHeight, letterDescs) {
        this._lastStyle = { asBillboard: false, color: new Color(), opacity: 1.0 };
        this._textureSize = 1;
        this._lineHeight = 1;
        this._chars = new Array();
        this._textureSize = textureSize;
        this._lineHeight = lineHeight;
        this._createMaterials(textures);
        // this._setTextures(textures);
        this.setLetterDescs(letterDescs);
    }
    setStyle(style) {
        if (this._lastStyle.asBillboard !== style.asBillboard) {
            this._changeBillboarding(style.asBillboard);
        }
        if (this._lastStyle.color !== style.color) {
            this._changeColor(style.color);
        }
        if (this._lastStyle.opacity !== style.opacity) {
            this._changeOpacity(style.opacity);
        }
        if (!!style.transparencyRules) {
            this._changeTransparecyRules(style.transparencyRules);
        }
        this._lastStyle = style;
    }
    /**
     * number of pixel of an edge of a quadratic texture
     */
    getTextureSize() {
        return this._textureSize;
    }
    /**
     * the distance from the upper line to the upperline of the next textline
     */
    getLineHeight() {
        return this._lineHeight;
    }
    setLetterDescs(chars) {
        this._chars = chars;
    }
    /**
     * returns information about the alignment, position, etc. of the letter
     * @param cp codepoint of the letter
     */
    getLetterDesc(cp) {
        let res;
        this._chars.filter((e) => e.id === cp).forEach((e) => {
            res = e;
        });
        return res;
    }
    getMaterials() {
        return this._materials;
    }
    _createMaterials(textures) {
        this._materials = new Array();
        textures.forEach((tex) => {
            tex.magFilter = LinearFilter;
            tex.minFilter = LinearFilter;
            this._materials.push(this._createMaterial(tex));
        });
    }
    _createMaterial(texture) {
        const params = {};
        params.uniforms = JSON.parse(JSON.stringify(DistanceFieldShader.uniforms));
        params.uniforms.map.value = texture;
        params.uniforms.mcolor.value = this._lastStyle.color;
        params.uniforms.opacity.value = (this._lastStyle.opacity !== null) ? this._lastStyle.opacity : 1;
        params.fragmentShader = DistanceFieldShader.createMSDFShader();
        params.vertexShader = DistanceFieldShader.createVertexShader(this._lastStyle.asBillboard);
        const material = new ShaderMaterial(params);
        material.side = DoubleSide;
        //  The order of the transparent / non-transparent objects must be kept, therefore the transparent flag must be set correctly.
        material.transparent = true;
        // However, the shader needs an alpha channel in order to draw the border of the font not pixelated (compare to anti aliasing).
        // Therefore, manual enable Blending
        material.blending = CustomBlending;
        material.blendEquation = AddEquation; // three js default
        material.blendSrc = SrcAlphaFactor; // three js default
        material.blendDst = OneMinusSrcAlphaFactor; // three  js default
        return material;
    }
    _changeBillboarding(asBillboard) {
        const shader = DistanceFieldShader.createVertexShader(asBillboard);
        this._materials.forEach((material) => {
            material.vertexShader = shader;
            material.needsUpdate = true;
        });
    }
    _changeColor(color) {
        this._materials.forEach((material) => {
            material.uniforms.mcolor.value = color;
        });
    }
    _changeOpacity(opacity) {
        this._materials.forEach((material) => {
            material.uniforms.opacity.value = opacity != null ? opacity : 1;
            material.needsUpdate = true;
        });
    }
    _changeTransparecyRules(rules) {
        this._materials.forEach((material) => {
            //  The order of the transparent / non-transparent objects must be kept, therefore the transparent flag must be set correctly.
            material.transparent = rules.transparent === undefined || rules.transparent;
            // However, the shader needs an alpha channel in order to draw the border of the font not pixelated (compare to anti aliasing).
            // Therefore, manual enable Blending
            material.blending = rules.blending || CustomBlending;
            material.blendEquation = rules.blendEquation || AddEquation; // three js default
            material.blendSrc = rules.blendSrc || SrcAlphaFactor; // three js default
            material.blendDst = rules.blendDst || OneMinusSrcAlphaFactor; // three  js default
            material.needsUpdate = true;
        });
    }
}
//# sourceMappingURL=Text2DFontMSDF.js.map